import { Product, ProductModel } from "@core/models/product.model";

export interface ProductVersionModel {
  description: string;
  gfhVersionNumber: number;
  id: string;
  minimumTradeAmount: number;
  minimumTradeAmountCurrency: string;
  product: ProductModel;
  productId: string;
  startDate: string;
  status: number;
  utcInsertDate: string;
  utcUpdateDate: string;
  version: string;
}

export class ProductVersion {
  description = "";
  gfhVersionNumber = 0;
  id = "";
  minimumTradeAmount = 0;
  minimumTradeAmountCurrency = "";
  product = new Product();
  productId = "";
  startDate = "";
  status = 0;
  utcInsertDate = "";
  utcUpdateDate = "";
  version = "";

  constructor(dto?: ProductVersionModel) {
    if (!dto) {
      return;
    }
    this.description = dto.description;
    this.gfhVersionNumber = dto.gfhVersionNumber;
    this.id = dto.id;
    this.minimumTradeAmount = dto.minimumTradeAmount;
    this.minimumTradeAmountCurrency = dto.minimumTradeAmountCurrency;
    this.product = dto.product;
    this.productId = dto.productId;
    this.startDate = dto.startDate;
    this.status = dto.status;
    this.utcInsertDate = dto.utcInsertDate;
    this.utcUpdateDate = dto.utcUpdateDate;
    this.version = dto.version;
  }
}
